import React from "react";
import { useTranslation } from 'react-i18next';
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

export const About = ({ isOpen, onClose }) => {
  const { t } = useTranslation();
  return (
    <Modal open={isOpen} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 500,
          bgcolor: "background.paper",
          p: 4,
          borderRadius: 1,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "20px",
          }}
        >
          <Typography variant="h6" component="h2">
            {t('AboutTitle')}
          </Typography>
          <p
            style={{
              textAlign: "center",
            }}
          >
            {t('AboutBody')}
          </p>
          <p>
            {t('Copyright')}, {new Date().getFullYear()}
          </p>
        </Box>
      </Box>
    </Modal>
  );
};
